<bn-loading-overlay></bn-loading-overlay>
<div class="bn-form-group row">
  <div class="col">
    <h4>Solicitação de Renúncia</h4>
  </div>
  <div class="justify-content-end">
  </div>
</div>
<div class="row">
    <div class="container">
        <h4 *ngIf="iniciado && !janelaRenuncia" class="color-red">Período para renúncia ainda não disponibilizado</h4>
        <h4 *ngIf="carregandoJanela">Período para renúncia de ...</h4>
        <h4 *ngIf="janelaRenuncia">
          Período para renúncia de {{ janelaRenuncia?.dataInicioVigencia | date: 'dd/MM/yyyy' }} a {{ janelaRenuncia?.dataFimVigencia | date: 'dd/MM/yyyy' }} {{ periodoDeRenunciaEncerrado ? 'encerrado' : '' }}
        </h4>

       <div class="justificado">
           Será permitido ao Agente Financeiro realizar a RENÚNCIA da Cobertura Máxima de Inadimplência disponível referente à carteira contratada na primeira tranche (2020) do PEAC-FGI, sendo os valores das garantias liberadas alocados ao longo de 9 bimestres, conforme valor especificado pelo renunciante.
           <br><br>

           Os valores renunciados serão distribuídos bimestralmente da seguinte forma:<br>
           - 50% do valor renunciado será acrescido ao limite do renunciante;<br>
           - os demais 50% do valor renunciado serão distribuídos, entre todos os demais agentes financeiros e o renunciante, observando o atual método de distribuição.<br>

           <br>

          <span class="color-red">
           <b>Atenção!!!</b>
           <br>
              Quando a Cobertura Máxima de Inadimplência do Agente Financeiro for superior ao valor de Exposição do FGI PEAC a esse mesmo Agente Financeiro, o montante correspondente à diferença entre a Cobertura Máxima de Inadimplência do Agente Financeiro e o valor de Exposição do FGI PEAC a esse mesmo Agente Financeiro não será revertido em aumento do limite disponível de cobertura para a carteira corrente de Operações contratadas no âmbito do Peac-FGI.
           <br><br>
             Ademais, caso o renunciante não participe da rodada de distribuição, o valor que seria alocado a ele será distribuído aos demais, conforme método de distribuição.
           </span>
       </div>
   </div>
</div>

<br>

<h5>Limite por agente financeiro</h5>

<div class="container">
    <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()" *ngIf="pesquisaForm">
        <div class="mb-3 row">
          <div class="col">
            <h3>Filtros de pesquisa</h3>
          </div>
          <div class="col-auto">
            <button
              *ngIf="podeCadastrarRenuncia && ehAgenteFinanceiro"
              type="button"
              class="btn btn-primary no-margin"
              [routerLink]="['../', 'cadastro']"
              placement="bottom">
              <i class="fa fa-file-signature"></i> Solicitação de Renúncia
            </button>
            <button type="button" class="btn btn-light" [disabled]="ehAgenteFinanceiro" (click)="limparPesquisa()">Limpar</button>
            <button #focusableSubmit type="button" class="btn btn-success" [disabled]="ehAgenteFinanceiro" (keydown.enter)="buscar()" (click)="buscar()">Pesquisar</button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-9">
            <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
            <select id="agenteFinanceiro" class="form-select" formControlName="agenteFinanceiro">
                <option [value]="null" selected>Todos</option>
                <option *ngFor="let agente of agentesFinanceiros" [value]="agente.cnpj">{{ agente.nome }}</option>
            </select>
          </div>
          <div class="bn-form-group col-md-3">
            <label class="form-label" for="tranche">Cesta:</label>
            <select formControlName="tranche" id="tranche" class="form-select">
              <option *ngFor="let tranche of tranches" [value]="tranche.id">
                {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})
              </option>
            </select>
          </div>
        </div>
      </form>
</div>

<app-renuncia-listagem
  [renuncias]="renuncias"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  [ehAgenteFinanceiro]="ehAgenteFinanceiro"
  *ngIf="pesquisado"
  (aoMudarPagina)="mudancaPagina($event)"
  (exportarLista)="exportarLista()"
  >
</app-renuncia-listagem>
